import React, {useCallback, useRef, useState} from 'react';
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchData from "../hooks/use-fetch-data.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";
import acceptanceRulesService from "../../../../services/web/acceptance-rules-service.js";

const initialFilters = {reason: "", city: ""}

const AcceptanceRulesList = () => {
    const navigate = navigateHook();

    const [filter, setFilter] = useState([]);
    const [filterValues, setFilterValues] = useState(initialFilters);

    const {data} = useQuery({
        queryFn: () => acceptanceRulesService.list(filter).then(({data}) => data),
        queryKey: ["list", {filter}]
    });

    const fetchData = useFetchData();

    const [columnDefs,] = useState([
        { field: "id", headerName: "ID", width: 60, sort: "desc"},
        { field: "city", headerName: "Município", flex: 1},
        { field: "reason", headerName: "Naturezas", flex: 1},
    ]);

    const gridRef = useRef(undefined);

    const apply = useCallback(() => {
        setFilter(Object.keys(filterValues).map(field => ({field, type: "like", value: filterValues[field]})))
    }, [filterValues])

    const clear = useCallback(() => {
        setFilterValues(initialFilters);
        setFilter([]);
    }, [])

    useGlobalKey("Enter", apply);
    useGlobalKey("Escape", clear);

    const onCellClicked = ({data}) => {
        navigate(`/acceptance-rules/form/${data.id}`)
    };

    return (
        <Template>
            <Template.Header>
                <Template.Title>Regras de monitoramento automático</Template.Title>

                <Button target={"primary"} onClick={() => navigate("/acceptance-rules/form")}>
                    <FaPlus/> Adicionar regra
                </Button>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body className={"grid grid-cols-12 gap-4"}>
                        <SelectComponent
                            classNameWrapper={"col-span-6"}
                            value={filterValues.reason}
                            options={fetchData.reasons}
                            label={"Natureza"}
                            onChange={(value) => setFilterValues(prev => ({...prev, reason: value?.value}))}
                        />

                        <div className="col-span-6 flex justify-between gap-4">
                            <SelectComponent
                                classNameWrapper={"w-full"}
                                value={filterValues.city}
                                options={fetchData.city}
                                label={"Município"}
                                onChange={(value) => setFilterValues(prev => ({...prev, city: value?.value}))}
                            />

                            <div className={"flex gap-2"}>
                                <Button target={"default"} onClick={clear} title={"Limpar"}>
                                    <FaEraser />
                                </Button>
                                <Button onClick={apply} title={"Buscar"}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className={"h-[calc(100vh-153px)] aggrid-row-pointer"}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={data ?? []}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default AcceptanceRulesList;